<template>
    <div class="page page--gradient-background">
        <section :class="wrapperClass">
            <header :class="'row__header'">
                <back-button :isAbsolute="false"
                    isBlack
                    routeToHome
                />

                <h1>{{ $t('jurisdictionRequirements.requirement') }}</h1>
            </header>
            <component :is="componentToLoad"
                :loading="loading"
                v-bind="componentProps"
                @submit="submitRequirement"
            />
        </section>
    </div>
</template>

<script>
// Api
import {
    api,
} from '@shared/setups/api';

// 3rd party Libs
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Shared Modules
import sharedEpicTypes from '@shared/epics/types.js';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';
import ukQuiz from '@webapp/modules/customer-first/components/requirements/uk-quiz.vue';
import malaysianStatement from '@webapp/modules/customer-first/components/requirements/domestic-ringgit-borrowing-statement.vue';
import ukSelfCategorisation from '@webapp/modules/customer-first/components/requirements/uk-self-categorisation-assessment/uk-investor-assessment.vue';

export default {
    name: 'requirement',
    components: {
        ukQuiz,
        malaysianStatement,
        ukSelfCategorisation,
        backButton,
    },
    beforeRouteEnter(_to, _from, next) {
        next((vm) => {
            if (!vm.componentToLoad) {
                next('/home/overview');
            }
        });
    },
    beforeRouteLeave(_to, _from, next) {
        if (!this.submitted) {
            this.onCancel();
        }

        next();
    },
    props: {
        componentToLoad: {
            type: String,
            required: true,
        },
        componentProps: {
            type: Object,
            default: () => ({}),
        },
        requirement: {
            type: Object,
            default: null,
        },
        routeToRedirect: {
            type: String,
            default: null,
        },
        avoidCredentialsUpdate: {
            type: Boolean,
            default: false,
        },
        onSuccess: {
            type: Function,
            default: () => ({}),
        },
        onCancel: {
            type: Function,
            default: () => ({}),
        },
    },
    data() {
        return {
            loading: false,
            submitted: false,
        };
    },
    computed: {
        ...mapGetters([
            'getLatestSimpleValidationError',
            'userPermissions',
            'isMobileDevice',
        ]),

        wrapperClass() {
            return [
                'requirement', {
                    'requirement-fullscreen': this.isMobileDevice,
                },
            ];
        },
    },
    watch: {
        getLatestSimpleValidationError: 'onError',
        userPermissions() {
            if (this.routeToRedirect) {
                this.$router.replace(this.routeToRedirect);
            }

            this.loading = false;
        },
    },
    methods: {
        ...mapActions({
            updateUserCredentials: sharedEpicTypes.GET_USER_PERMISSIONS,
        }),

        async submitRequirement(params) {
            this.loading = true;
            const response = await api.submitRequirement(params || {}, {
                id: this.requirement.id,
            });

            this.onSubmissionSuccess(response);
        },

        async onSubmissionSuccess(result) {
            this.submitted = true;
            if (!this.avoidCredentialsUpdate) {
                await this.updateUserCredentials();
            }

            if (this.onSuccess) {
                this.onSuccess(result);
            }
        },

        onError(error) {
            const fetchErrors = this.utilGlobalHandleErrorMessages(error);

            this.$notify({
                type: 'error',
                text: fetchErrors.message,
            });

            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.requirement {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 2rem;
}

.requirement-fullscreen {
    margin: 0;
}
</style>